<template>
  <div v-if="visible" class="reply-email-modal-overlay" @click.self="closeModal">
    <div class="reply-email-modal">
      <!-- 弹窗头部 -->
      <div class="modal-header">
        <div class="header-content">
          <h3 class="modal-title">发送您的信件给 {{ recipientName }}</h3>
          <div class="header-divider"></div>
          <div class="star-icon">
            <i class="el-icon-star-off"></i>
            <span class="plus-icon">+</span>
          </div>
        </div>
        <div class="close-btn" @click="closeModal">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <!-- 弹窗内容 -->
      <div class="modal-content">
        <!-- 文本输入区域 -->
        <div class="text-input-container">
          <el-input v-model="emailContent" type="textarea" :rows="16" placeholder="在此处编辑您的信件..." class="email-textarea"
            :maxlength="maxLength" show-word-limit resize="none" @input="handleInput" />
          <div class="char-count">{{ emailContent.length }}/{{ maxLength }}</div>
        </div>

        <!-- 媒体展示区域 -->
        <div v-if="uploadedFiles.length > 0" class="media-preview-section">
          <div class="media-header">
            <i class="el-icon-picture"></i>
            <span>已添加的媒体文件</span>
          </div>
          <div class="media-grid">
            <div v-for="(file, index) in uploadedFiles" :key="index" class="media-item">
              <!-- 图片预览 -->
              <div v-if="file.type.startsWith('image')" class="image-preview">
                <img :src="file.url" :alt="file.name" class="preview-image" />
                <div class="media-overlay">
                  <div class="media-actions">
                    <i class="el-icon-delete" @click="removeMedia(index)"></i>
                  </div>
                </div>
              </div>

              <!-- 视频预览 -->
              <div v-else-if="file.type.startsWith('video')" class="video-preview">
                <video :src="file.url" class="preview-video" muted></video>
                <div class="video-play-icon">
                  <i class="el-icon-video-play"></i>
                </div>
                <div class="media-overlay">
                  <div class="media-actions">
                    <i class="el-icon-delete" @click="removeMedia(index)"></i>
                  </div>
                </div>
              </div>

              <!-- 其他文件类型 -->
              <div v-else class="file-preview">
                <i class="el-icon-document"></i>
                <span class="file-name">{{ file.name }}</span>
                <div class="media-overlay">
                  <div class="media-actions">
                    <i class="el-icon-delete" @click="removeMedia(index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showWarning" class="limit-warning">{{ warningMessage }}</div>
        <!-- 底部信息 -->
        <div class="modal-footer">
          <div class="info-section">
            <div class="info-icon">
              <i class="el-icon-info"></i>
            </div>
            <span class="info-text">
              已添加 {{uploadedFiles.filter(f => f.type.startsWith('image')).length}}/5 张图片，{{uploadedFiles.filter(f =>
                f.type.startsWith('video')).length}}/3 个视频。文件大小限制：12 MB。
            </span>
          </div>
          <div class="action-buttons">
            <el-button class="send-media-btn" @click="handleSendMedia" :disabled="isUploading">
              <i class="el-icon-camera"></i>
              选择媒体
            </el-button>

            <el-button type="primary" class="send-letter-btn" @click="handleSendLetter" :loading="isSending"
              :disabled="!emailContent.trim() || emailContent.length < 150">
              <i class="el-icon-message"></i>
              发送邮件
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <attachment ref="attachmentDom" :chatUserInfo="attachmentUserInfo" @send-sonMediaMessage="getSonMediaMessage" :currentMessageType="currentMessageType">
    </attachment>
  </div>
</template>

<script>
import attachment from '@/views/talkytimes/views/message/components/attachment.vue'
import { sendLetter } from '@/api/talkytimes/message'
export default {
  name: 'ReplyEmailModal',
  components: {
    attachment
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    recipientName: {
      type: String,
      default: 'rick'
    },
    recipientId: {
      type: Number,
      default: 0
    },
    maxLength: {
      type: Number,
      default: 3500
    },
    // 对方用户信息
    userInfo: {
      type: Object,
      default: () => ({})
    },
    // 己方用户信息
    currentUserInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      emailContent: '',
      isSending: false,
      isUploading: false,
      uploadedFiles: [],
      showWarning: false,
      warningMessage: '',
      currentMessageType: 'email'
    }
  },
  computed: {
    attachmentUserInfo() {
      return {
        userDetail: {
          avatar_large: this.userInfo.avatar_large,
          name: this.userInfo.name
        },
        platformUserId: this.currentUserInfo.platformUserId || '',
        userId: this.userInfo.id || this.userInfo.id_user || ''
      }
    },
    imageCount() {
      return this.uploadedFiles.filter(file =>
        (file.type && file.type.startsWith('image')) ||
        (file.name && file.name.includes('图片'))
      ).length;
    },
    videoCount() {
      return this.uploadedFiles.filter(file =>
        (file.type && file.type.startsWith('video')) ||
        (file.name && file.name.includes('视频'))
      ).length;
    },
    canAddMore() {
      return this.imageCount < 5 || this.videoCount < 3;
    },
    totalFileCount() {
      return this.uploadedFiles.length;
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },

    handleInput(value) {
      this.emailContent = value;
    },

    async handleSendMedia() {
      // 检查图片数量限制
      if (this.imageCount >= 5) {
        this.$message.warning('图片数量已达到上限（最多5张），无法继续添加图片');
        return;
      }

      // 检查视频数量限制
      if (this.videoCount >= 3) {
        this.$message.warning('视频数量已达到上限（最多3个），无法继续添加视频');
        return;
      }

      // 检查总文件数量
      if (this.uploadedFiles.length >= 8) {
        this.$message.warning('总文件数量不能超过8个（5张图片 + 3个视频）');
        return;
      }

      // 打开 attachment 窗口
      if (this.$refs.attachmentDom) {
        this.$refs.attachmentDom.init()
      }
    },

    // 处理从 attachment 组件返回的媒体消息
    getSonMediaMessage(mediaData) {
      console.log(mediaData, 'mediaData')
      if (!mediaData || !mediaData.dataMsgList) return;

      console.log(mediaData.dataMsgList, 'mediaData.dataMsgList')

      // 检查当前图片和视频数量
      const currentImages = this.imageCount;
      const currentVideos = this.videoCount;

      // 统计要添加的图片和视频数量
      let newImages = 0;
      let newVideos = 0;

      mediaData.dataMsgList.forEach(file => {
        // 通过 originalName 字段判断文件类型
        if (file.originalName && file.originalName.includes('图片')) {
          newImages++;
        } else if (file.originalName && file.originalName.includes('视频')) {
          newVideos++;
        } else {
          // 如果没有 originalName 字段，尝试通过 type 判断
          if (file.type && file.type.startsWith('image')) {
            newImages++;
          } else if (file.type && file.type.startsWith('video')) {
            newVideos++;
          }
        }
      });

      // 检查是否会超出限制
      if (currentImages + newImages > 5) {
        this.showLimitWarning(`图片数量超出限制！当前已有${currentImages}张图片，选择了${newImages}张图片，最多只能添加${5 - currentImages}张图片`);
        this.$refs.attachmentDom.visible = false;
        return;
      }

      if (currentVideos + newVideos > 3) {
        this.showLimitWarning(`视频数量超出限制！当前已有${currentVideos}个视频，选择了${newVideos}个视频，最多只能添加${3 - currentVideos}个视频`);
        this.$refs.attachmentDom.visible = false;
        return;
      }

      // 检查总文件数量
      const totalFiles = this.uploadedFiles.length + mediaData.dataMsgList.length;
      if (totalFiles > 8) {
        this.showLimitWarning(`总文件数量超出限制！当前已有${this.uploadedFiles.length}个文件，选择了${mediaData.dataMsgList.length}个文件，最多只能添加${8 - this.uploadedFiles.length}个文件`);
        this.$refs.attachmentDom.visible = false;
        return;
      }

      // 通过所有检查后，添加文件
      let addedCount = 0;
      mediaData.dataMsgList.forEach(file => {
        // 根据 originalName 确定文件类型
        let fileType = 'image/jpeg'; // 默认类型
        if (file.originalName && file.originalName.includes('图片')) {
          fileType = 'image/jpeg';
        } else if (file.originalName && file.originalName.includes('视频')) {
          fileType = 'video/mp4';
        } else if (file.type) {
          fileType = file.type;
        }

        // 添加到上传文件列表
        this.uploadedFiles.push({
          name: file.name || file.originalName || `文件_${Date.now()}`,
          type: fileType,
          size: file.size || 0,
          url: file.url || file.originalUrl || file,
          id: file.id || file.idPhoto || file.idVideo || Date.now(), // 文件ID
          vip: file.vip || false // VIP状态
        });
        addedCount++;
      });

      // 关闭 attachment 窗口
      this.$refs.attachmentDom.visible = false;

      if (addedCount > 0) {
        this.$message.success(`成功添加 ${addedCount} 个文件`);
      }
    },

    removeMedia(index) {
      this.uploadedFiles.splice(index, 1);
      this.$message.success('文件已移除');
    },

    showLimitWarning(message) {
      this.warningMessage = message;
      this.showWarning = true;

      // 2秒后自动隐藏
      setTimeout(() => {
        this.showWarning = false;
        this.warningMessage = '';
      }, 2000);
    },

    async handleSendLetter() {
      if (!this.emailContent.trim()) {
        this.$message.warning('请输入邮件内容');
        return;
      }

      if (this.emailContent.length < 150) {
        this.$message.warning(`邮件内容至少需要150个字符，当前只有${this.emailContent.length}个字符`);
        return;
      }

      this.isSending = true;
      try {
        // 根据API格式构建数据
        const emailData = {
          content: this.emailContent,
          idUserTo: this.recipientId || 0, // 收件人用户ID
          vip: false,
          images: this.uploadedFiles
            .filter(file => file.type && file.type.startsWith('image'))
            .map(file => ({ idPhoto: file.id || parseInt(file.name.match(/\d+/)?.[0] || 0) })),
          videos: this.uploadedFiles
            .filter(file => file.type && file.type.startsWith('video'))
            .map(file => ({
              idVideo: file.id || parseInt(file.name.match(/\d+/)?.[0] || 0),
            }))
        };
        console.log(emailData, 'emailData')
        // 发送邮件
        await sendLetter(emailData);

        this.$message.success('邮件发送成功');
        this.closeModal();
        this.resetForm();
      } catch (error) {
        this.$message.error('发送失败，请重试');
      } finally {
        this.isSending = false;
      }
    },

    async sendEmail(emailData) {
      // 这里实现发送邮件的API调用
      // 示例：
      // return await sendEmailAPI(emailData);
      console.log('发送邮件数据:', emailData);

      // 模拟API调用
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ success: true });
        }, 1000);
      });
    },

    resetForm() {
      this.emailContent = '';
      this.uploadedFiles = [];
    }
  }
}
</script>

<style scoped lang="scss">
.reply-email-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}

.reply-email-modal {
  background: #fff;
  border-radius: 12px;
  width: 95%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  background: #fff;

  .header-content {
    display: flex;
    align-items: center;
    gap: 12px;

    .modal-title {
      font-size: 18px;
      font-weight: 600;
      color: #212529;
      margin: 0;
    }

    .header-divider {
      width: 1px;
      height: 20px;
      background-color: #dee2e6;
    }

    .star-icon {
      position: relative;
      color: #6c757d;
      font-size: 16px;

      .plus-icon {
        position: absolute;
        top: -2px;
        right: -2px;
        font-size: 8px;
        color: #6c757d;
      }
    }
  }

  .close-btn {
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    transition: background-color 0.2s;
    color: #6c757d;

    &:hover {
      background-color: #f8f9fa;
    }

    i {
      font-size: 18px;
    }
  }
}

.modal-content {
  padding: 24px;
  max-height: calc(80vh - 80px);
  overflow-y: auto;
}

.text-input-container {
  position: relative;
  margin-bottom: 20px;

  .email-textarea {
    .el-textarea__inner {
      border: 1px solid #dee2e6;
      border-radius: 8px;
      padding: 16px;
      font-size: 14px;
      line-height: 1.6;
      resize: none;

      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }
  }

  .char-count {
    position: absolute;
    bottom: 8px;
    right: 12px;
    font-size: 12px;
    color: #6c757d;
    background: rgba(255, 255, 255, 0.9);
    padding: 2px 6px;
    border-radius: 4px;
  }


}

.media-preview-section {
  margin: 20px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;

  .media-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #495057;

    i {
      color: #6c757d;
    }
  }

  .media-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 12px;
    max-height: 200px;
    overflow-y: auto;
  }

  .media-item {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dee2e6;
    transition: all 0.2s ease;

    &:hover {
      .media-overlay {
        opacity: 1;
      }
    }

    .image-preview,
    .video-preview {
      position: relative;
      width: 100%;
      height: 100px;
      overflow: hidden;

      .preview-image,
      .preview-video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .video-play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 32px;
        height: 32px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
      }
    }

    .file-preview {
      position: relative;
      width: 100%;
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #f8f9fa;
      padding: 12px;

      i {
        font-size: 24px;
        color: #6c757d;
        margin-bottom: 8px;
      }

      .file-name {
        font-size: 10px;
        color: #6c757d;
        text-align: center;
        word-break: break-word;
        line-height: 1.2;
      }
    }

    .media-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.2s ease;

      .media-actions {
        display: flex;
        gap: 12px;

        i {
          color: #fff;
          font-size: 16px;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          transition: background-color 0.2s;

          &:hover {
            background: rgba(255, 255, 255, 0.3);
          }
        }
      }
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  .info-section {
    display: flex;
    align-items: center;
    gap: 8px;

    .info-icon {
      color: #6c757d;
      font-size: 14px;
    }

    .info-text {
      font-size: 12px;
      color: #6c757d;
    }
  }

  .action-buttons {
    display: flex;
    gap: 12px;

    .send-media-btn {
      border: 1px solid #dee2e6;
      background: #fff;
      color: #409eff;

      &:hover {
        border-color: #409eff;
        background: #f0f8ff;
      }

      i {
        margin-right: 4px;
      }
    }

    .send-letter-btn {
      background: #6f42c1;
      border-color: #6f42c1;

      &:hover {
        background: #5a32a3;
        border-color: #5a32a3;
      }

      i {
        margin-right: 4px;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .reply-email-modal {
    width: 95%;
    margin: 20px;
  }

  .modal-footer {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;

    .action-buttons {
      width: 100%;
      justify-content: space-between;
    }
  }
}

::v-deep .el-dialog {
  border-radius: 30px;
}

.limit-warning {
  font-size: 14px;
  color: #dc3545;
  font-weight: 500;
  margin: 8px 0;
  padding: 8px 12px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  animation: fadeInOut 2s ease-in-out;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  20% {
    opacity: 1;
    transform: translateY(0);
  }

  80% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

::v-deep .el-dialog__header {
  padding: 0;
  z-index: 1 !important;
}

::v-deep .el-dialog__body {
  padding: 24px;
}

::v-deep .el-dialog {
  // height: 100%;
  margin-top: 5vh !important;

  .el-dialog__body {
    height: calc(90vh - 5px);
    box-sizing: border-box;
  }
}
</style>